module.exports = "/images/wechat.svg?ddd7bdf873c1cba78a54cfe567bdf8f7";